export class APIRequestError extends Error {
  error: Error | unknown;

  constructor(name: string, message: string, error: unknown) {
    super(message);
    this.name = name || 'APIRequestError';
    this.error = error;
  }
}
